export enum QrRecordTypes {
    QRCODE = "qr_code",
    QROFFTHESHELF = "qr_off_the_shelf",
}
